export default __webpack_public_path__ + "static/media/straightbaguette.4cba9f39.svg";